module.exports = __webpack_public_path__ + "img/icon-file.48658119.svg";